import { SalesSectionProps } from '.'

export const swapSectionData: SalesSectionProps = {
  headingText: 'Trade anything. No registration, no hassle.',
  bodyText: 'Trade any token on Binance Smart Chain in seconds, just by connecting your wallet.',
  reverse: false,
  primaryButton: {
    to: '/swap',
    text: 'Trade Now',
    external: false,
  },
  secondaryButton: {
    to: 'https://docs.ampleswap.com/',
    text: 'Learn',
    external: true,
  },
  images: {
    path: '/images/home/earn/',
    attributes: [
      { src: 'pie', alt: 'Pie chart' },
      { src: 'stonks', alt: 'Stocks chart' },
      { src: 'folder', alt: 'Folder with ample token' },
    ],
  },
  /* images: {
    path: '/images/home/trade/',
    attributes: [
      { src: 'BNB', alt: 'BNB token' },
      { src: 'BTC', alt: 'BTC token' },
      { src: 'AMPLE', alt: 'Ample token' },
    ],
  }, */
}

export const earnSectionData: SalesSectionProps = {
  headingText: 'Earn passive income with crypto.',
  bodyText: 'AmpleSwap makes it easy to make your crypto work for you.',
  reverse: true,
  primaryButton: {
    to: '/farms',
    text: 'Explore',
    external: false,
  },
  secondaryButton: {
    to: 'https://docs.ampleswap.com/yield-farming.html',
    text: 'Learn',
    external: true,
  },
  images: {
    path: '/images/home/earn/',
    attributes: [
      { src: 'pie', alt: 'Pie chart' },
      { src: 'stonks', alt: 'Stocks chart' },
      { src: 'folder', alt: 'Folder with ample token' },
    ],
  },
}

export const cakeSectionData: SalesSectionProps = {
  headingText: 'AmpleSwap',
  bodyText:
    'AMM Dex on BNB Chain, AlveyChain & DecimalChain providing friendly trading and better project support',
  reverse: false,
  primaryButton: {
    to: '/swap?outputCurrency=0x19857937848c02afbde8b526610f0f2f89e9960d',
    text: 'Trade Now',
    external: null,
  },
  secondaryButton: {
    to: '',
    text: '',
    external: true,
  },
  images: {
    path: '/images/home/trade/',
    attributes: [
      { src: 'BNB', alt: '' },
      { src: 'BTC', alt: '' },
      { src: 'AMPLE', alt: 'Ample token' },
    ],
  }, 
}
